<template>
  <div class="wrapper">
    <div class="content" id="contentInfo-dynamics">
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        :id="'contentInfoFloor_' + index"
      >
        <div class="item-title">
          {{ item.name }}
          <div class="look-more pointer" @click="goList(item)">
            查看更多<i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <!-- 有热推则显示 -->
        <div class="item-info" v-if="hot(item.informationList).length">
          <div class="item-left">
            <div
              class="brick pointer"
              v-for="(hotItem, hotIndex) in hot(item.informationList).slice(
                0,
                2
              )"
              :key="hotIndex"
              @click="goDetail(hotItem)"
            >
              <goodImg class="goodImg" :img="hotItem.coverImgUrl" />

              <div class="brick-title ell_two">
                {{ hotItem.title }}
              </div>
            </div>
          </div>
          <div
            class="item-right"
            v-if="hot(item.informationList).slice(2, 9).length"
          >
            <div class="hot-title">热门推荐</div>
            <div class="hot-list">
              <div
                class="hot-item pointer"
                v-for="(hotItem, hotIndex) in hot(item.informationList).slice(
                  2,
                  9
                )"
                :key="hotIndex"
                @click="goDetail(hotItem)"
              >
                <div class="hot-index">{{ hotIndex + 1 }}</div>
                <div class="hot-subtitle ell_one">
                  {{ hotItem.title }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 有无热推的默认 -->
        <div class="item-info" v-else>
          <div
            class="item-normal"
            v-if="item.informationList.slice(0, 5).length > 0"
          >
            <div
              class="item-normal-info pointer ell_one"
              v-for="(info, infoIndex) in item.informationList.slice(0, 5)"
              :key="infoIndex"
              @click="goDetail(info)"
            >
              {{ info.title }}
            </div>
          </div>
          <div
            class="item-normal"
            v-if="item.informationList.slice(5, 10).length > 0"
          >
            <div
              class="item-normal-info pointer ell_one"
              v-for="(info, infoIndex) in item.informationList.slice(5, 10)"
              :key="infoIndex"
              @click="goDetail(info)"
            >
              {{ info.title }}
            </div>
          </div>
          <div
            class="item-normal"
            v-if="item.informationList.slice(10, 15).length > 0"
          >
            <div
              class="item-normal-info pointer ell_one"
              v-for="(info, infoIndex) in item.informationList.slice(10, 15)"
              :key="infoIndex"
              @click="goDetail(info)"
            >
              {{ info.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="list-empty" v-if="list.length === 0">
        <img src="@/assets/img/good/noGood.png" />
        暂无资讯
      </div>
    </div>
  </div>
</template>

<script>
import goodImg from '@/components/img'

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  components: { goodImg },
  methods: {
    hot (list) {
      return list.filter((item) => item.hot)
    },
    goList (item) {
      this.$router.push({
        path: '/contentInfoList',
        query: {
          id: item.id
        }
      })
    },
    goDetail (item) {
      window.open(
        this.$router.resolve({
          path: '/contentInfoDetail',
          query: {
            id: item.id
          }
        }).href
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding-top: 40px;

  .content {
    width: 100%;

    .item {
      margin-bottom: 40px;

      .item-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px 0px;
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        color: #333333;

        .look-more {
          font-size: 14px;
          line-height: normal;
          color: #2e4c95;
          white-space: nowrap;
        }
      }

      .item-info {
        display: flex;

        .item-left {
          display: flex;

          .brick {
            width: 386px;
            border-radius: 16px;
            overflow: hidden;
            background: #f6f5fa;
            margin-right: 20px;

            .goodImg {
              width: 100%;
              // height: 334px;
              height: 364px;
              // object-fit: fill;
              // object-fit: cover;
              object-fit: contain;

              /deep/ .goodImg {
                width: 100%;
                height: 100%;

                .goodsImg {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            .brick-title {
              padding: 12px 20px 0;
              margin-bottom: 12px;
              font-size: 16px;
              font-weight: bold;
              line-height: 22px;
              word-break: break-all;
              color: #2c2c2c;
            }
          }
        }

        .item-right {
          flex: 1;
          overflow: hidden;
          border-radius: 16px;
          border: 1px solid #f5f6fa;
          padding: 4px 24px;

          .hot-title {
            padding: 16px 0px;
            font-size: 16px;
            font-weight: bold;
            line-height: 22px;
            color: #2c2c2c;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
          }

          .hot-list {
            .hot-item {
              display: flex;
              padding: 16px 0px;
              line-height: 20px;
              border-bottom: 1px solid #f5f6fa;

              .hot-index {
                margin-right: 8px;
                color: #fff;
                background: #2e4c95;
                width: 20px;
                height: 20px;
                text-align: center;
                border-radius: 50%;
              }

              &:nth-child(n + 4) {
                .hot-index {
                  background: #aeb2bb;
                }
              }

              .hot-subtitle {
                flex: 1;
                font-size: 14px;
                line-height: 20px;
                color: #2c2c2c;
              }
            }
          }
        }

        .item-normal {
          margin-right: 20px;
          border-radius: 16px;
          border: 1px solid #f5f6fa;
          padding: 4px 24px;
          width: calc((100% - 40px) / 3);

          &:last-child {
            margin-right: 0;
          }

          .item-normal-info {
            padding: 16px 0px;
            line-height: 19px;
            font-size: 14px;
            color: #2c2c2c;
            border-bottom: 1px solid #f5f6fa;

            &::before {
              content: "";
              display: inline-block;
              width: 8px;
              height: 8px;
              background: #2e4c95;
              border-radius: 50%;
              margin-right: 8px;
              margin-bottom: 1px;
            }
          }
        }
      }
    }

    .list-empty {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      min-height: 560px;
    }
  }
}
</style>
